import { IS_BEING_VALIDATED_MARKER } from './constants.mjs';

export default function markAsAsyncValidationEnded({ target }) {
  delete target.dataset[IS_BEING_VALIDATED_MARKER];
}
